import styled from 'styled-components'
import Button from 'react-bootstrap/Button'
import { ReactElement } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { colors } from '../../../const/theme'
import {
  Card,
  DropdownWrapper,
  EditableDropdown,
  FlexWrapper
} from '../../../components'
import strings from '../../../locale/en'
import { BranchFilterProps, BranchActionProps } from './typings'

export const TableRow = styled.tr`
  vertical-align: baseline;
`

export const CardWrapper = styled(Card)`
  width: 45%;
  padding: 0 32px 16px;
  @media (max-width: 415px) {
    width: 100%;
    margin-bottom: 16px;
  }
`

export const BranchFilterSection = ({
  institueList,
  instituteValue,
  handleinstituteSelect
}: BranchFilterProps): ReactElement => {
  return (
    <FlexWrapper>
      <DropdownWrapper>
        <EditableDropdown
          dropdownList={institueList}
          handleSelect={handleinstituteSelect}
          placeholder={strings.menu.branch.selectCoachingCenter}
          defaultValue={instituteValue}
        />
      </DropdownWrapper>
    </FlexWrapper>
  )
}

export const Icon = styled(Button)`
  border-color: ${colors.white};
  color: ${colors.gray};
  text-transform: capitalize;
  &:hover,
  &:focus {
    border-color: ${colors.white};
    background: ${colors.white};
    color: ${colors.black};
  }
  max-width: 40px;
`

const BranchActionWrapper = styled.div`
  display: flex;
`

export const BranchAction = ({
  handleView,
  handleEdit,
  handleDelete
}: BranchActionProps): ReactElement => {
  return (
    <BranchActionWrapper>
      <Icon variant="outline-light" onClick={handleDelete}>
        <FontAwesomeIcon
          icon={['far', 'trash-alt']}
          style={{ marginRight: 10 }}
        />
      </Icon>
      <Icon variant="outline-light" onClick={handleView}>
        <FontAwesomeIcon icon={['far', 'eye']} style={{ marginRight: 10 }} />
      </Icon>
      <Icon variant="outline-light" onClick={handleEdit}>
        <FontAwesomeIcon icon={['far', 'edit']} style={{ marginRight: 10 }} />
      </Icon>
    </BranchActionWrapper>
  )
}

export default BranchAction
